<template>
  <Popper
    :class="quick == true ? 'quick' : ''"
    :placement="placement"
    :hover="true"
    :arrow="true"
    offset-distance="6"
  >
    <span
      class="cursor-pointer hover:opacity-80"
      :class="iconColorClass"
    >
      <div
        v-if="hideIcon"
        class="h-20 w-20 cursor-pointer bg-transparent"
      />
      <svg
        v-if="!hasTitle && !hideIcon"
        class="h-4 w-4"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7ZM8.00008 6.16609V11.5195H6.00008L6.00008 6.16609H8.00008ZM8.00008 4.25431L8.00008 2.04108L6.00008 2.04108L6.00008 4.25431L8.00008 4.25431Z"
          fill="#313545"
        />
      </svg>

      <div
        v-if="hasTitle"
        class="rounded-full px-2 py-1"
        :class="contentClass"
      >
        {{ title }}
      </div>
    </span>
    <template #content>
      <div
        class="w-36 rounded-md px-2 py-1 text-center text-2xs"
        :class="contentClass"
      >
        <slot />
      </div>
    </template>
  </Popper>
</template>

<script>
import { defineComponent } from 'vue';
import Popper from 'vue3-popper';

export default defineComponent({
  components: {
    Popper,
  },
  props: {
    colorScheme: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    placement: {
      type: String,
      required: false,
      default: 'top',
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    quick: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    iconColorClass() {
      if (this.colorScheme == 'light') {
        return 'text-light-gray';
      } else {
        return 'text-dark-gray';
      }
    },
    contentClass() {
      if (this.colorScheme == 'light') {
        return 'text-dark-gray bg-light-gray';
      } else {
        return 'text-light-gray bg-dark-gray';
      }
    },
    hasTitle() {
      if (this.title != null && this.title?.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
});
</script>

<style scoped>
:root {
  --popper-theme-background-color: #333333;
  --popper-theme-background-color-hover: #333333;
  --popper-theme-text-color: #ffffff;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 16px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>
